// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".halo[data-v-d3ec3142]{-webkit-box-shadow:0 0 0 4px rgba(91,206,174,.3137254901960784);box-shadow:0 0 0 4px rgba(91,206,174,.3137254901960784)}", ""]);
// Exports
module.exports = exports;
